import { injectable } from "inversify";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/ErrorEntity";
import UserEntity from "../../entities/UserEntity";
import UserRepository from "../../repositories/UserRepository";

interface _Props {
    userRepository: UserRepository;
}

@injectable()
export default class GetAvailableUsersUseCase {
    private userRepository: UserRepository;
    
    constructor(props: _Props) {
        this.userRepository = props.userRepository;
    }
    
    public call = async (_:{query?: string, scheduleId: string, date: Date}): Promise<Either<ErrorEntity, UserEntity[]>> => {
        return await this.userRepository.searchUsersForShift(_);
    }
}

export const GetAvailableUsersUseCaseName = "GetAvailableUsersUseCase";